export const SET_QUOTE = 'SET_QUOTE';
export const SET_QUOTE_MODIFIED = 'SET_QUOTE_MODIFIED';
export const SET_QUOTE_REVISION = 'SET_QUOTE_REVISION';
export const SET_QUOTE_VEHICLE = 'SET_QUOTE_VEHICLE';
export const SET_QUOTE_MODEL_YEAR = 'SET_QUOTE_MODEL_YEAR';
export const SET_LEAD_TYPE = 'SET_LEAD_TYPE';
export const SET_STATUS = 'SET_STATUS';
export const SET_SECURITY_TOKEN = 'SET_SECURITY_TOKEN';
export const SET_QUOTE_PURCHASE_METHODS = 'SET_QUOTE_PURCHASE_METHODS';

export const SET_QUOTEV25 = 'SET_QUOTEV25';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';

export default {
    SET_QUOTE,
    SET_QUOTE_MODIFIED,
    SET_QUOTE_REVISION,
    SET_QUOTE_VEHICLE,
    SET_QUOTE_MODEL_YEAR,
    SET_LEAD_TYPE,
    SET_STATUS,
    SET_SECURITY_TOKEN,
    SET_QUOTE_PURCHASE_METHODS,
    SET_QUOTEV25,
    SET_LOADING,
    SET_ERROR,
};
